import React, { useState, useEffect } from 'react';
import {
    Typography,
    Grid,
    TextField,
    MenuItem,
    Box,
    Checkbox,
    FormControlLabel,
    Divider,
    Chip,
    Button,
    Snackbar,
    Alert,
    Modal
} from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import { axiosInstance, localAxiosToken, localAxiosGet } from '../../../../Axios/axios';
import TokenExpirePopup from '../../../../components/TokenExpirePopup';
import { useNavigate } from 'react-router-dom';


const terminationChecklist = [
    { key: 'exitInterview', label: 'Exit interview scheduled' },
    { key: 'assetsCollected', label: 'Company assets collected (Laptop, Phone, ID)' },
    { key: 'finalPayroll', label: 'Final payroll processed' },
    { key: 'accessRevoked', label: 'Access permissions revoked' },
    { key: 'terminationProcessCompleted', label: 'All Check are completed. Complete the Termination Process' }
];

const getPayrollMonthsOptions = () => {
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const financialYearEndMonth = 2;
    const financialYearEndYear = currentMonth <= financialYearEndMonth ? currentYear : currentYear + 1;

    const options = [];
    let year = currentYear;
    let month = currentMonth;

    while (year < financialYearEndYear || (year === financialYearEndYear && month <= financialYearEndMonth)) {
        options.push(`${months[month]} ${year}`);
        month++;
        if (month > 11) {
            month = 0;
            year++;
        }
    }

    let prevMonthDate = new Date(currentDate);
    prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);
    const prevMonthOption = `${months[prevMonthDate.getMonth()]} ${prevMonthDate.getFullYear()}`;

    return [prevMonthOption, ...options];
};


const ExitProcess = ({ userId, onUpdate }) => {
    const payrollMonthsOptions = getPayrollMonthsOptions();

    const [terminationProcessStatus, setTerminationProcessStatus] = useState('');
    const Token = localStorage.getItem('accessToken');
    const [finalExitdata, setFinalExitData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [previousExitData, setPreviousExitData] = useState(null);
    const [hasExistingData, setHasExistingData] = useState(false); // Track if data exists


    const [exitDetails, setExitDetails] = useState({
        type: 'Resignation',
        date_of_notice: '',
        final_date_of_exit: '',
        notice_period_days: '',
        reason_for_exit: '',
    });

    const [checklistData, setChecklistData] = useState({
        exitInterview: {
            exit_interview_scheduled: false,
            interview_date: ''
        },
        assetsCollected: {
            assets_collected: false,
            assets_details: ''
        },
        finalPayroll: {
            final_payroll_processed: false,
            payroll_month: ''
        },
        accessRevoked: {
            access_revoked: false,
            revocation_details: ''
        },
        terminationProcessCompleted: false
    });

    const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
    const navigate = useNavigate()
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const fetchgetExitRehireInitialData = async () => {
        if (!userId) return;

        try {
            setLoading(true);
            const token = localStorage.getItem('accessToken');
            const response = await axiosInstance(localAxiosGet(`/hr/getEmployeeExitRehireDetails/${userId}`, token));

            if (response.data && response.data.status === "SUCCESS") {
                const { exitDetails } = response.data.result;
                setPreviousExitData(exitDetails);
                setFinalExitData(exitDetails);

                // ✅ FIX: Get the first item from the exitDetails array
                const currentExitData = exitDetails?.[0] || null;
                const currentStatus = currentExitData?.exit_status || '';

                if (currentStatus === 'Completed') {
                    setHasExistingData(true);
                    setTerminationProcessStatus(currentStatus);
                    return;
                }

                // Check if there's existing data (Initiate/InProgress means data was saved)
                if (currentStatus === 'Initiate' || currentStatus === 'InProgress') {
                    setHasExistingData(true);
                    setTerminationProcessStatus(currentStatus);

                    // ✅ FIX: Prefill form using the first item from the array
                    setExitDetails({
                        type: currentExitData.type || 'Resignation',
                        date_of_notice: currentExitData.date_of_notice || '',
                        final_date_of_exit: currentExitData.final_date_of_exit || '',
                        notice_period_days: currentExitData.notice_period_days || '',
                        reason_for_exit: currentExitData.reason_for_exit || ''
                    });

                    setChecklistData({
                        exitInterview: {
                            exit_interview_scheduled: currentExitData.exit_interview_scheduled || false,
                            interview_date: currentExitData.interview_date || ''
                        },
                        assetsCollected: {
                            assets_collected: currentExitData.assets_collected || false,
                            assets_details: currentExitData.assets_details || ''
                        },
                        finalPayroll: {
                            final_payroll_processed: currentExitData.final_payroll_processed || false,
                            payroll_month: currentExitData.payroll_month || ''
                        },
                        accessRevoked: {
                            access_revoked: currentExitData.access_revoked || false,
                            revocation_details: currentExitData.revocation_details || ''
                        },
                        terminationProcessCompleted: currentExitData.exit_status === 'Completed'
                    });
                } else {
                    // No existing data - keep form empty and status as empty
                    setHasExistingData(false);
                    setTerminationProcessStatus('');
                }
            }
        } catch (error) {
            console.error("Error fetching employee details:", error);
            if (error.response?.status === 401) {
                setOpenTokenExpirePopup(true);
            } else {
                setSnackbar({
                    open: true,
                    message: 'Failed to load employee exit details',
                    severity: 'error'
                });
            }
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchgetExitRehireInitialData();
    }, [userId]);




    const handleExitChange = (event) => {
        const { name, value } = event.target;
        setExitDetails(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleChecklistChange = (key, event) => {
        const isChecked = event.target.checked;

        if (key === 'terminationProcessCompleted') {
            setChecklistData(prev => ({
                ...prev,
                [key]: isChecked
            }));

            if (isChecked) {
                setTerminationProcessStatus('Completed');
            } else {
                setTerminationProcessStatus(finalExitdata?.status === 'Completed' ? 'Initiate' : finalExitdata?.status || 'Initiate');
            }
        } else {
            setChecklistData(prev => ({
                ...prev,
                [key]: {
                    ...prev[key],
                    [`${key === 'exitInterview' ? 'exit_interview_scheduled' :
                        key === 'assetsCollected' ? 'assets_collected' :
                            key === 'finalPayroll' ? 'final_payroll_processed' :
                                'access_revoked'}`]: isChecked,

                    ...(key === 'exitInterview' && { interview_date: isChecked ? prev[key].interview_date : '' }),
                    ...(key === 'finalPayroll' && { payroll_month: isChecked ? prev[key].payroll_month : '' }),
                    ...(key === 'accessRevoked' && { revocation_details: isChecked ? prev[key].revocation_details : '' }),
                    ...(key === 'assetsCollected' && { assets_details: isChecked ? prev[key].assets_details : '' }),
                },
            }));
        }
    };

    const handleConditionalChecklistChange = (key, name, value) => {
        setChecklistData(prev => ({
            ...prev,
            [key]: {
                ...prev[key],
                [name]: value,
            },
        }));
    };


    const handleSubmit = async () => {
        if (!exitDetails.type) {
            toast.error("Type is mandatory.");
            return;
        }

        if (!userId) {
            toast.error("User ID is mandatory.");
            return;
        }

        setLoading(true);

        const status = checklistData.terminationProcessCompleted ? 'Completed' : 'Initiate';

        const buildConditionalPayload = (key, boolKey, dataKeys) => {
            if (checklistData[key][boolKey]) {
                const data = { [boolKey]: true };
                dataKeys.forEach(dk => {
                    const value = checklistData[key][dk];
                    if (value) {
                        data[dk] = value;
                    } else if (dk.includes('date') || dk.includes('month')) {
                        data[dk] = null;
                    }
                });
                return data;
            }
            return {
                [boolKey]: false,
                ...dataKeys.reduce((acc, dk) => ({ ...acc, [dk]: null }), {})
            };
        };

        const apiPayload = {
            user_id: userId,
            type: exitDetails.type,
            date_of_notice: exitDetails.date_of_notice || null,
            final_date_of_exit: exitDetails.final_date_of_exit || null,
            notice_period_days: exitDetails.notice_period_days ? parseInt(exitDetails.notice_period_days) : 0,
            reason_for_exit: exitDetails.reason_for_exit,

            ...buildConditionalPayload('exitInterview', 'exit_interview_scheduled', ['interview_date']),
            ...buildConditionalPayload('assetsCollected', 'assets_collected', ['assets_details']),
            ...buildConditionalPayload('finalPayroll', 'final_payroll_processed', ['payroll_month']),
            ...buildConditionalPayload('accessRevoked', 'access_revoked', ['revocation_details']),

            exit_status: status
        };

        try {
            const response = await axiosInstance(localAxiosToken('/hr/initiateEmployeeExit', apiPayload))

            if (response.data.status === 'SUCCESS') {
                setHasExistingData(true); // Mark that we now have data
                fetchgetExitRehireInitialData();
                setSnackbar({
                    open: true,
                    message: `Exit Process ${status === 'Completed' ? 'Completed' : terminationProcessStatus ? 'Updated' : 'Initiated'} successfully! 🎉`,
                    severity: 'success'
                })

                if (onUpdate) onUpdate();

            } else {
                setSnackbar({
                    open: true,
                    message: response.data.message.msg || 'Failed to save exit process',
                    severity: 'error'
                })

            }
        } catch (error) {
            console.log('Error while sending the Exit Details', error);
            if (error.response?.status === 401) {
                setOpenTokenExpirePopup(true);
            } else {
                setSnackbar({
                    open: true,
                    message: error.response?.message || 'Failed to save exit process details',
                    severity: 'error'
                })
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleCloseTokenExpirePopup = () => {
        setOpenTokenExpirePopup(false);
        navigate('/');
    };


    return (
        <Box sx={{ mt: 3 }}>


            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" color="error">
                    1. Termination or Resignation Details
                </Typography>
                {/* <Chip
                    label={`Status: ${terminationProcessStatus || 'Not Set'}`}
                    color={terminationProcessStatus === 'Completed' ? 'success' :
                        terminationProcessStatus === 'Initiate' ? 'warning' : 'default'}
                    variant="outlined"
                    size="small"
                /> */}

            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <TextField
                        select
                        fullWidth
                        size='medium'
                        label="Type"
                        name="type"
                        value={exitDetails.type}
                        onChange={handleExitChange}
                        required
                    >
                        <MenuItem value="Resignation">Resignation</MenuItem>
                        <MenuItem value="Termination">Termination</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <TextField
                        fullWidth
                        size='medium'
                        label="Date of Notice"
                        type="date"
                        name="date_of_notice"
                        value={exitDetails.date_of_notice}
                        onChange={handleExitChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <TextField
                        fullWidth
                        size='medium'
                        label="Final Date of Exit"
                        type="date"
                        name="final_date_of_exit"
                        value={exitDetails.final_date_of_exit}
                        onChange={handleExitChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <TextField
                        fullWidth
                        size='medium'
                        label="Notice Period (Days)"
                        type="number"
                        name="notice_period_days"
                        value={exitDetails.notice_period_days}
                        onChange={handleExitChange}
                        helperText="Actual notice period served."
                    />
                </Grid>

                <Grid item xs={12} sm={8}>
                    <TextField
                        fullWidth
                        size='medium'
                        label="Reason for Exit"
                        name="reason_for_exit"
                        value={exitDetails.reason_for_exit}
                        onChange={handleExitChange}
                        multiline
                        rows={2}
                    />
                </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" gutterBottom color="primary">
                2. Termination Process Checklist
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1, alignItems: 'flex-start' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checklistData.exitInterview.exit_interview_scheduled}
                                    onChange={(e) => handleChecklistChange('exitInterview', e)}
                                />
                            }
                            label={terminationChecklist.find(i => i.key === 'exitInterview').label}
                        />
                        {checklistData.exitInterview.exit_interview_scheduled && (
                            <TextField
                                label="Interview Date"
                                type="date"
                                size='small'
                                name="interview_date"
                                value={checklistData.exitInterview.interview_date}
                                onChange={(e) => handleConditionalChecklistChange('exitInterview', 'interview_date', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                sx={{ width: 180 }}
                            />
                        )}
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1, alignItems: 'flex-start' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size='medium'
                                    checked={checklistData.assetsCollected.assets_collected}
                                    onChange={(e) => handleChecklistChange('assetsCollected', e)}
                                />
                            }
                            label={terminationChecklist.find(i => i.key === 'assetsCollected').label}
                        />
                        {checklistData.assetsCollected.assets_collected && (
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Details of Assets Collected (e.g., Laptop model, accessories, dates)"
                                size="small"
                                name="assets_details"
                                value={checklistData.assetsCollected.assets_details}
                                onChange={(e) => handleConditionalChecklistChange('assetsCollected', 'assets_details', e.target.value)}
                                sx={{ minWidth: 400 }}
                            />
                        )}
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checklistData.finalPayroll.final_payroll_processed}
                                    onChange={(e) => handleChecklistChange('finalPayroll', e)}
                                />
                            }
                            label={terminationChecklist.find(i => i.key === 'finalPayroll').label}
                        />
                        {checklistData.finalPayroll.final_payroll_processed && (
                            <TextField
                                select
                                label="Payroll Month"
                                size="small"
                                name="payroll_month"
                                value={checklistData.finalPayroll.payroll_month}
                                onChange={(e) => handleConditionalChecklistChange('finalPayroll', 'payroll_month', e.target.value)}
                                sx={{ width: 250 }}
                            >
                                {(!payrollMonthsOptions.includes(checklistData.finalPayroll.payroll_month) && checklistData.finalPayroll.payroll_month) && (
                                    <MenuItem key={checklistData.finalPayroll.payroll_month} value={checklistData.finalPayroll.payroll_month}>
                                        {checklistData.finalPayroll.payroll_month} (Old)
                                    </MenuItem>
                                )}
                                {payrollMonthsOptions.map(month => (
                                    <MenuItem key={month} value={month}>{month}</MenuItem>
                                ))}
                            </TextField>
                        )}
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checklistData.accessRevoked.access_revoked}
                                    onChange={(e) => handleChecklistChange('accessRevoked', e)}
                                />
                            }
                            label={terminationChecklist.find(i => i.key === 'accessRevoked').label}
                        />
                        {checklistData.accessRevoked.access_revoked && (
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Revocation Details (Specify systems and date/time of revocation)"
                                size="small"
                                name="revocation_details"
                                value={checklistData.accessRevoked.revocation_details}
                                onChange={(e) => handleConditionalChecklistChange('accessRevoked', 'revocation_details', e.target.value)}
                                sx={{ minWidth: 400 }}
                            />
                        )}
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    size="small"
                                    checked={checklistData.terminationProcessCompleted}
                                    onChange={(e) => handleChecklistChange('terminationProcessCompleted', e)}
                                />
                            }
                            label={terminationChecklist.find(i => i.key === 'terminationProcessCompleted').label}
                        />
                    </Box>
                </Grid>
            </Grid>

            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? 'Saving...' :
                        (finalExitdata?.status === 'Completed' || checklistData.terminationProcessCompleted) ? 'Complete Exit Process' :
                            (hasExistingData) ? 'Save Exit Details' :
                                'Initiate Exit Process'}
                </Button>
            </Box>



            <Modal
                open={openTokenExpirePopup}
                onClose={handleCloseTokenExpirePopup}
                aria-labelledby="token-expire-modal-title"
                aria-describedby="token-expire-modal-description"
            >
                <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
            </Modal>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                    variant="filled"
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

        </Box>
    );
};

export default ExitProcess;